import Marquee from "react-fast-marquee";

const ITEMS = [
  "Authentische Srilankische Küche",
  "Wilhelmstraße 43 · Karlsruhe",
  "10 % Rabatt auf alles",
  "Frisch · Würzig · Hausgemacht",
  "Lieferung ab 20 €",
  "Ceylon Royal Kitchen",
];

export const MarqueeStrip = () => (
  <div className="bg-teal-dark border-y border-gold/20 py-5 overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl text-gold/90 px-8">{t}</span>
          <span className="text-gold text-xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
